module.exports = __webpack_public_path__ + "fea0dc8ba06776bfefcc72328daff76a.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/inner-ornament.png
// module id = 403
// module chunks = 0